const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/report/performance-classified',
    authenticatedEntryPathAdminExpert: '/app/report/performance-classified',
    authenticatedEntryPathStandard: '/app/report/performance-classified',
    authenticatedEntryPathHotKey: '/app/leads/hotkey',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig